import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Logo from '../components/Logo';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const LandingPage = () => {
  const navigate = useNavigate();
  const [branding, setBranding] = useState({ logo_url: '/taskpiece-logo.png', site_name: 'TaskPiece' });

  useEffect(() => {
    axios.get(`${API}/settings/branding`).then(r => setBranding(r.data)).catch(() => {});
    // Initialize animations
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.style.animationPlayState = 'running';
          e.target.classList.add('visible');
        }
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('.fade-up, .feature-card, .step, .flow-step, .corp-card, .price-card, .testimonial').forEach(el => {
      el.style.animationPlayState = 'paused';
      observer.observe(el);
    });

    // Nav scroll effect
    const handleScroll = () => {
      const nav = document.querySelector('nav');
      const y = window.scrollY;
      if (y > 100) {
        nav.style.background = 'rgba(255,255,255,0.97)';
        nav.style.boxShadow = '0 4px 30px rgba(0,0,0,0.1)';
      } else {
        nav.style.background = 'rgba(255,255,255,0.92)';
        nav.style.boxShadow = '0 1px 12px rgba(26,92,219,0.08)';
      }
    };
    window.addEventListener('scroll', handleScroll);

    // Counter animation
    setTimeout(() => {
      document.querySelectorAll('.hero-stat .num').forEach(el => {
        el.style.animation = 'countUp 0.8s ease forwards';
      });
    }, 500);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleGetStarted = (e) => {
    e.preventDefault();
    navigate('/signup');
  };

  const handleLogin = (e) => {
    e.preventDefault();
    navigate('/login');
  };

  return (
    <div className="landing-page-wrapper">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800;900&display=swap');
        *{margin:0;padding:0;box-sizing:border-box}
        :root{--bg:#f0f6ff;--bg2:#ffffff;--card:#ffffff;--border:#d0e2f7;--border2:#bdd4f0;--text:#0f2340;--muted:#4a6fa5;--accent:#1a5cdb;--accent2:#2d7cf6;--accent-light:#e8f1fd;--green:#059669;--amber:#d97706;--pink:#db2777;--shadow:0 2px 16px rgba(26,92,219,0.10)}
        html{scroll-behavior:smooth}
        .landing-page-wrapper{font-family:'Plus Jakarta Sans',sans-serif;background:var(--bg);color:var(--text);overflow-x:hidden}
        ::selection{background:rgba(26,92,219,0.18)}

        @keyframes float{0%,100%{transform:translateY(0)}50%{transform:translateY(-20px)}}
        @keyframes fadeUp{from{opacity:0;transform:translateY(40px)}to{opacity:1;transform:translateY(0)}}
        @keyframes fadeIn{from{opacity:0}to{opacity:1}}
        @keyframes pulse{0%,100%{opacity:1}50%{opacity:0.5}}
        @keyframes scaleIn{from{opacity:0;transform:scale(0.8)}to{opacity:1;transform:scale(1)}}
        @keyframes gradientMove{0%{background-position:0% 50%}50%{background-position:100% 50%}100%{background-position:0% 50%}}
        @keyframes countUp{from{opacity:0;transform:translateY(20px)}to{opacity:1;transform:translateY(0)}}
        @keyframes marquee{0%{transform:translateX(0)}100%{transform:translateX(-50%)}}
        .fade-up{animation:fadeUp 0.8s ease forwards;opacity:0}
        .fade-up-d1{animation-delay:0.1s}.fade-up-d2{animation-delay:0.2s}.fade-up-d3{animation-delay:0.3s}.fade-up-d4{animation-delay:0.4s}.fade-up-d5{animation-delay:0.5s}.fade-up-d6{animation-delay:0.6s}

        .container{max-width:1240px;margin:0 auto;padding:0 28px}
        section{padding:100px 0;position:relative}

        nav{position:fixed;top:0;left:0;right:0;z-index:1000;background:rgba(255,255,255,0.92);backdrop-filter:blur(20px);border-bottom:1px solid var(--border);transition:all 0.3s;box-shadow:0 1px 12px rgba(26,92,219,0.08)}
        nav .inner{max-width:1240px;margin:0 auto;padding:0 28px;display:flex;align-items:center;justify-content:space-between;height:68px}
        .logo{display:flex;align-items:center;gap:10px;text-decoration:none;cursor:pointer}
        .logo-icon{width:38px;height:38px;border-radius:12px;background:linear-gradient(135deg,#1a5cdb,#2d7cf6);display:flex;align-items:center;justify-content:center;font-size:18px;font-weight:900;color:#fff}
        .logo-text{font-size:20px;font-weight:800;background:linear-gradient(135deg,#1a5cdb,#2d7cf6);-webkit-background-clip:text;-webkit-text-fill-color:transparent}
        .logo-badge{font-size:9px;padding:2px 7px;border-radius:4px;background:rgba(217,119,6,0.12);color:#d97706;font-weight:700;margin-left:4px}
        nav ul{display:flex;gap:6px;list-style:none}
        nav ul a{text-decoration:none;color:#4a6fa5;font-size:14px;font-weight:600;padding:8px 16px;border-radius:10px;transition:all 0.2s;cursor:pointer}
        nav ul a:hover{color:#1a5cdb;background:rgba(26,92,219,0.08)}
        .nav-mobile-btn{display:none;align-items:center;gap:8px;padding:8px 18px;border-radius:10px;background:linear-gradient(135deg,#1a5cdb,#2d7cf6);color:#fff;font-size:14px;font-weight:700;border:none;cursor:pointer}
        .nav-cta{background:linear-gradient(135deg,#1a5cdb,#2d7cf6)!important;color:#fff!important;padding:10px 24px!important;border-radius:12px!important;font-weight:700!important}
        .nav-cta:hover{transform:translateY(-1px);box-shadow:0 4px 20px rgba(26,92,219,0.35)}

        .hero{min-height:100vh;display:flex;align-items:center;position:relative;overflow:hidden;padding-top:80px;background:linear-gradient(160deg,#e8f1fd 0%,#f8fbff 50%,#eef5ff 100%)}
        .hero-bg{position:absolute;inset:0;overflow:hidden}
        .hero-orb{position:absolute;border-radius:50%;filter:blur(80px);opacity:0.18}
        .hero-orb-1{width:600px;height:600px;background:#2d7cf6;top:-200px;right:-100px;animation:float 8s ease-in-out infinite}
        .hero-orb-2{width:400px;height:400px;background:#93c5fd;bottom:-100px;left:-100px;animation:float 10s ease-in-out infinite 2s}
        .hero-orb-3{width:300px;height:300px;background:#bfdbfe;top:40%;left:40%;animation:float 12s ease-in-out infinite 4s}
        .hero-grid{position:absolute;inset:0;background-image:radial-gradient(rgba(26,92,219,0.06) 1px,transparent 1px);background-size:40px 40px}
        .hero .container{display:grid;grid-template-columns:1fr 1fr;gap:60px;align-items:center;position:relative;z-index:2}
        .hero-tag{display:inline-flex;align-items:center;gap:8px;padding:6px 16px;border-radius:30px;background:rgba(26,92,219,0.08);border:1px solid rgba(26,92,219,0.2);font-size:13px;font-weight:600;color:#1a5cdb;margin-bottom:24px}
        .hero-tag .dot{width:8px;height:8px;border-radius:50%;background:#059669;animation:pulse 2s infinite}
        .hero h1{font-size:56px;font-weight:900;line-height:1.1;margin-bottom:20px;color:#0f2340}
        .hero h1 .gradient{background:linear-gradient(135deg,#1a5cdb,#2d7cf6,#0ea5e9);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-size:200% 200%;animation:gradientMove 4s ease infinite}
        .hero p{font-size:18px;color:#4a6fa5;line-height:1.7;margin-bottom:32px;max-width:520px}
        .hero-btns{display:flex;gap:14px;margin-bottom:40px}
        .btn{display:inline-flex;align-items:center;gap:8px;padding:16px 32px;border-radius:14px;font-size:16px;font-weight:700;text-decoration:none;transition:all 0.3s;cursor:pointer;border:none;background:transparent}
        .btn-primary{background:linear-gradient(135deg,#1a5cdb,#2d7cf6);color:#fff;box-shadow:0 4px 24px rgba(26,92,219,0.28)}
        .btn-primary:hover{transform:translateY(-2px);box-shadow:0 8px 40px rgba(26,92,219,0.42)}
        .btn-secondary{background:#ffffff;color:#1a5cdb;border:1.5px solid #bdd4f0}
        .btn-secondary:hover{background:#e8f1fd;border-color:#1a5cdb}
        .hero-stats{display:flex;gap:40px}
        .hero-stat .num{font-size:32px;font-weight:900;background:linear-gradient(135deg,#1a5cdb,#059669);-webkit-background-clip:text;-webkit-text-fill-color:transparent}
        .hero-stat .label{font-size:13px;color:#4a6fa5;margin-top:2px}

        .hero-visual{position:relative;height:500px}
        .hero-card{position:absolute;background:#ffffff;backdrop-filter:blur(20px);border:1px solid var(--border);border-radius:20px;padding:24px;animation:float 6s ease-in-out infinite;box-shadow:0 8px 32px rgba(26,92,219,0.10)}
        .hero-card-1{top:20px;left:20px;width:300px;animation-delay:0s}
        .hero-card-2{top:180px;right:0;width:260px;animation-delay:2s}
        .hero-card-3{bottom:40px;left:40px;width:280px;animation-delay:4s}
        .card-avatar{width:40px;height:40px;border-radius:50%;background:linear-gradient(135deg,#1a5cdb,#0ea5e9);display:flex;align-items:center;justify-content:center;font-size:14px;font-weight:700;color:#fff}
        .card-row{display:flex;align-items:center;gap:12px;margin-bottom:12px}
        .card-name{font-size:14px;font-weight:700;color:#0f2340}
        .card-sub{font-size:12px;color:#4a6fa5}
        .card-price{font-size:20px;font-weight:800;color:#059669}
        .card-tag{display:inline-block;padding:3px 10px;border-radius:6px;font-size:11px;font-weight:600;background:rgba(26,92,219,0.08);color:#1a5cdb;margin-right:4px}
        .escrow-badge{display:flex;align-items:center;gap:8px;padding:10px 16px;border-radius:12px;background:rgba(5,150,105,0.08);border:1px solid rgba(5,150,105,0.2);margin-top:12px}
        .escrow-badge span{font-size:12px;color:#059669;font-weight:700}

        .marquee-section{padding:40px 0;border-top:1px solid var(--border);border-bottom:1px solid var(--border);overflow:hidden;background:#fff}
        .marquee-track{display:flex;animation:marquee 30s linear infinite;width:max-content}
        .marquee-item{display:flex;align-items:center;gap:10px;padding:0 40px;white-space:nowrap;font-size:15px;font-weight:600;color:#4a6fa5}
        .marquee-item .m-dot{width:6px;height:6px;border-radius:50%;background:#1a5cdb}

        .section-header{text-align:center;margin-bottom:60px}
        .section-tag{display:inline-flex;align-items:center;gap:6px;padding:5px 14px;border-radius:20px;background:rgba(26,92,219,0.08);border:1px solid rgba(26,92,219,0.18);font-size:12px;font-weight:700;color:#1a5cdb;margin-bottom:16px;text-transform:uppercase;letter-spacing:0.5px}
        .section-header h2{font-size:42px;font-weight:900;margin-bottom:14px;color:#0f2340}
        .section-header h2 .gradient{background:linear-gradient(135deg,#1a5cdb,#2d7cf6);-webkit-background-clip:text;-webkit-text-fill-color:transparent}
        .section-header p{font-size:17px;color:#4a6fa5;max-width:600px;margin:0 auto;line-height:1.7}

        .features-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:20px}
        .feature-card{background:var(--card);border:1px solid var(--border);border-radius:20px;padding:32px;transition:all 0.4s;position:relative;overflow:hidden;box-shadow:0 2px 12px rgba(26,92,219,0.06)}
        .feature-card::before{content:'';position:absolute;top:0;left:0;right:0;height:3px;background:linear-gradient(90deg,var(--accent),var(--accent2));opacity:0;transition:opacity 0.3s}
        .feature-card:hover{border-color:rgba(26,92,219,0.3);transform:translateY(-4px);box-shadow:0 16px 48px rgba(26,92,219,0.12)}
        .feature-card:hover::before{opacity:1}
        .feature-icon{width:56px;height:56px;border-radius:16px;display:flex;align-items:center;justify-content:center;font-size:26px;margin-bottom:18px}
        .feature-card h3{font-size:18px;font-weight:800;margin-bottom:8px;color:#0f2340}
        .feature-card p{font-size:14px;color:#4a6fa5;line-height:1.7}

        .how-it-works{background:linear-gradient(180deg,#fff,rgba(26,92,219,0.03),#fff)}
        .steps{display:grid;grid-template-columns:repeat(4,1fr);gap:24px;position:relative}
        .steps::before{content:'';position:absolute;top:45px;left:12%;right:12%;height:2px;background:linear-gradient(90deg,transparent,rgba(26,92,219,0.25),rgba(5,150,105,0.25),transparent)}
        .step{text-align:center;position:relative}
        .step-num{width:56px;height:56px;border-radius:50%;background:linear-gradient(135deg,#1a5cdb,#2d7cf6);display:flex;align-items:center;justify-content:center;font-size:22px;font-weight:900;margin:0 auto 18px;position:relative;z-index:2;box-shadow:0 4px 20px rgba(26,92,219,0.25);color:#fff}
        .step-icon{font-size:32px;margin-bottom:12px}
        .step h3{font-size:16px;font-weight:800;margin-bottom:6px;color:#0f2340}
        .step p{font-size:13px;color:#4a6fa5;line-height:1.6}

        .escrow-section{position:relative;overflow:hidden;background:#fff}
        .escrow-visual{display:grid;grid-template-columns:1fr 1fr;gap:60px;align-items:center}
        .escrow-flow{display:flex;flex-direction:column;gap:16px}
        .flow-step{display:flex;gap:16px;padding:20px;border-radius:16px;background:var(--bg);border:1px solid var(--border);transition:all 0.3s}
        .flow-step:hover{border-color:rgba(26,92,219,0.3);background:rgba(26,92,219,0.04)}
        .flow-num{width:40px;height:40px;border-radius:12px;background:linear-gradient(135deg,#1a5cdb,#2d7cf6);display:flex;align-items:center;justify-content:center;font-weight:800;flex-shrink:0;color:#fff}
        .flow-step h4{font-size:15px;font-weight:700;margin-bottom:4px;color:#0f2340}
        .flow-step p{font-size:13px;color:#4a6fa5;line-height:1.5}

        .corporate-section{background:linear-gradient(180deg,#fff,rgba(26,92,219,0.03),#fff)}
        .corp-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:16px;margin-bottom:40px}
        .corp-card{background:#fff;border:1px solid var(--border);border-radius:16px;padding:24px;text-align:center;transition:all 0.3s;box-shadow:0 2px 10px rgba(26,92,219,0.06)}
        .corp-card:hover{border-color:rgba(26,92,219,0.3);transform:translateY(-3px);box-shadow:0 8px 28px rgba(26,92,219,0.12)}
        .corp-icon{font-size:36px;margin-bottom:12px}
        .corp-card h3{font-size:15px;font-weight:800;margin-bottom:6px;color:#0f2340}
        .corp-card p{font-size:12px;color:#4a6fa5;line-height:1.6}

        .pricing-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:24px}
        .price-card{background:#fff;border:1px solid var(--border);border-radius:20px;padding:36px;text-align:center;transition:all 0.3s;position:relative;box-shadow:0 2px 12px rgba(26,92,219,0.07)}
        .price-card.featured{border-color:rgba(26,92,219,0.4);background:linear-gradient(180deg,rgba(26,92,219,0.05),#ffffff)}
        .price-card.featured::before{content:'MOST POPULAR';position:absolute;top:-14px;left:50%;transform:translateX(-50%);padding:5px 16px;border-radius:20px;background:linear-gradient(135deg,#1a5cdb,#2d7cf6);font-size:11px;font-weight:800;letter-spacing:0.5px;color:#fff}
        .price-card:hover{transform:translateY(-4px);box-shadow:0 16px 48px rgba(26,92,219,0.15)}
        .price-label{font-size:14px;font-weight:700;color:#4a6fa5;margin-bottom:8px}
        .price-amount{font-size:44px;font-weight:900;margin-bottom:4px;color:#0f2340}
        .price-amount .currency{font-size:20px;color:#4a6fa5}
        .price-sub{font-size:13px;color:#4a6fa5;margin-bottom:24px}
        .price-features{text-align:left;margin-bottom:28px;list-style:none;padding:0}
        .price-features li{display:flex;align-items:center;gap:10px;padding:8px 0;font-size:14px;color:#4a6fa5;border-bottom:1px solid rgba(26,92,219,0.06)}
        .price-features li::before{content:'✓';color:#059669;font-weight:800;font-size:14px}
        .price-btn{display:block;width:100%;padding:14px;border-radius:12px;font-size:15px;font-weight:700;text-align:center;text-decoration:none;transition:all 0.3s;cursor:pointer;border:none}
        .price-btn-primary{background:linear-gradient(135deg,#1a5cdb,#2d7cf6);color:#fff}
        .price-btn-secondary{background:rgba(26,92,219,0.06);color:#1a5cdb;border:1.5px solid rgba(26,92,219,0.2)}

        .testimonials-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:20px}
        .testimonial{background:#fff;border:1px solid var(--border);border-radius:20px;padding:28px;transition:all 0.3s;box-shadow:0 2px 12px rgba(26,92,219,0.07)}
        .testimonial:hover{border-color:rgba(26,92,219,0.3);box-shadow:0 8px 28px rgba(26,92,219,0.12)}
        .test-stars{color:#d97706;font-size:14px;margin-bottom:14px}
        .test-text{font-size:14px;color:#4a6fa5;line-height:1.7;margin-bottom:18px;font-style:italic}
        .test-author{display:flex;align-items:center;gap:12px}
        .test-avatar{width:40px;height:40px;border-radius:50%;background:linear-gradient(135deg,#1a5cdb,#0ea5e9);display:flex;align-items:center;justify-content:center;font-size:13px;font-weight:700;color:#fff}
        .test-name{font-size:14px;font-weight:700;color:#0f2340}
        .test-role{font-size:12px;color:#4a6fa5}

        .cta-section{text-align:center;position:relative;overflow:hidden}
        .cta-box{background:linear-gradient(135deg,#1a5cdb,#2d7cf6);border:none;border-radius:28px;padding:80px 60px;position:relative}
        .cta-box h2{font-size:40px;font-weight:900;margin-bottom:16px;color:#fff}
        .cta-box p{font-size:17px;color:rgba(255,255,255,0.8);margin-bottom:36px;max-width:550px;margin-left:auto;margin-right:auto}

        footer{border-top:1px solid var(--border);padding:60px 0 30px;background:#fff}
        .footer-grid{display:grid;grid-template-columns:2fr 1fr 1fr 1fr 1fr;gap:40px;margin-bottom:40px}
        .footer-brand p{font-size:14px;color:#4a6fa5;line-height:1.7;margin-top:14px}
        .footer-col h4{font-size:14px;font-weight:700;margin-bottom:16px;color:#0f2340}
        .footer-col a{display:block;font-size:13px;color:#4a6fa5;text-decoration:none;padding:4px 0;transition:color 0.2s;cursor:pointer}
        .footer-col a:hover{color:#1a5cdb}
        .footer-bottom{border-top:1px solid var(--border);padding-top:24px;display:flex;justify-content:space-between;align-items:center;font-size:13px;color:#4a6fa5}
        .footer-badges{display:flex;gap:12px}
        .footer-badge{padding:4px 12px;border-radius:6px;background:rgba(26,92,219,0.06);border:1px solid var(--border);font-size:11px;font-weight:600;color:#1a5cdb}

        @media(max-width:900px){
          .hero .container,.escrow-visual{grid-template-columns:1fr}
          .hero-visual{display:none}
          .features-grid,.pricing-grid,.testimonials-grid{grid-template-columns:1fr 1fr}
          .steps,.corp-grid{grid-template-columns:1fr 1fr}
          .footer-grid{grid-template-columns:1fr 1fr}
          .hero h1{font-size:40px}
          nav ul{display:none}
          .section-header h2{font-size:32px}
          .cta-box{padding:50px 28px}
          .cta-box h2{font-size:28px}
        }
        @media(max-width:600px){
          .features-grid,.pricing-grid,.testimonials-grid{grid-template-columns:1fr}
          .steps,.corp-grid{grid-template-columns:1fr 1fr}
          .footer-grid{grid-template-columns:1fr 1fr}
          .hero h1{font-size:32px}
          .hero p{font-size:16px}
          .hero-btns{flex-direction:column;gap:10px}
          .hero-btns .btn{justify-content:center;width:100%}
          .hero-stats{gap:24px;flex-wrap:wrap}
          .hero-stat .num{font-size:26px}
          section{padding:60px 0}
          .container{padding:0 16px}
          .section-header{margin-bottom:36px}
          .section-header h2{font-size:26px}
          .section-header p{font-size:15px}
          .cta-box{padding:40px 20px;border-radius:20px}
          .cta-box h2{font-size:24px}
          .footer-grid{grid-template-columns:1fr}
          .footer-bottom{flex-direction:column;gap:12px;text-align:center}
          .footer-badges{justify-content:center}
          .nav-mobile-btn{display:flex!important}
        }
      `}</style>

      {/* NAV */}
      <nav>
        <div className="inner">
          <div className="logo" onClick={() => navigate('/')}>
            {branding.logo_url ? (
              <img src={branding.logo_url} alt={branding.site_name} style={{ height: 38, maxWidth: 200, objectFit: 'contain' }} />
            ) : (
              <Logo style={{ height: 38, maxWidth: 200, objectFit: 'contain' }} className="" />
            )}
          </div>
          <ul>
            <li><a onClick={() => navigate('/explore')} data-testid="nav-explore">Explore</a></li>
            <li><a onClick={handleLogin}>Login</a></li>
            <li><a onClick={handleGetStarted} className="nav-cta">Get Started Free →</a></li>
          </ul>
          <button className="nav-mobile-btn" onClick={handleGetStarted}>Get Started →</button>
        </div>
      </nav>

      {/* HERO */}
      <section className="hero">
        <div className="hero-bg">
          <div className="hero-orb hero-orb-1"></div>
          <div className="hero-orb hero-orb-2"></div>
          <div className="hero-orb hero-orb-3"></div>
          <div className="hero-grid"></div>
        </div>
        <div className="container">
          <div>
            <div className="hero-tag fade-up"><span className="dot"></span> India's #1 Freelancer Marketplace</div>
            <h1 className="fade-up fade-up-d1">Hire India's<br /><span className="gradient">Top Freelancers</span><br />with Escrow Safety</h1>
            <p className="fade-up fade-up-d2">50,000+ verified Indian freelancers. Secure escrow payments. Auto invoicing. UPI payments. Built for individuals & corporates.</p>
            <div className="hero-btns fade-up fade-up-d3">
              <a onClick={handleGetStarted} className="btn btn-primary">Start Hiring — Free →</a>
              <a onClick={handleGetStarted} className="btn btn-secondary">🏢 For Corporates</a>
            </div>
            <div className="hero-stats fade-up fade-up-d4">
              <div className="hero-stat"><div className="num">50,000+</div><div className="label">Verified Freelancers</div></div>
              <div className="hero-stat"><div className="num">₹120Cr+</div><div className="label">Escrow Processed</div></div>
              <div className="hero-stat"><div className="num">4.8★</div><div className="label">Avg. Satisfaction</div></div>
            </div>
          </div>
          <div className="hero-visual">
            <div className="hero-card hero-card-1">
              <div className="card-row"><div className="card-avatar">AS</div><div><div className="card-name">Arjun Sharma</div><div className="card-sub">Bengaluru · ⭐ 4.9</div></div></div>
              <div style={{fontSize:'14px',fontWeight:700,marginBottom:'8px'}}>Build React Website</div>
              <div><span className="card-tag">React</span><span className="card-tag">Next.js</span><span className="card-tag">Tailwind</span></div>
              <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginTop:'14px',paddingTop:'12px',borderTop:'1px solid #d0e2f7'}}><span style={{fontSize:'12px',color:'#4a6fa5'}}>Starting at</span><span className="card-price">₹18,000</span></div>
              <div className="escrow-badge"><span>🔒</span><span>Escrow Protected</span></div>
            </div>
            <div className="hero-card hero-card-2">
              <div className="card-row"><div className="card-avatar" style={{background:'linear-gradient(135deg,#0ea5e9,#1a5cdb)'}}>SR</div><div><div className="card-name">Sneha Reddy</div><div className="card-sub">Hyderabad · ⭐ 4.8</div></div></div>
              <div style={{fontSize:'14px',fontWeight:700,marginBottom:'8px'}}>Mobile App UI/UX</div>
              <div><span className="card-tag">Figma</span><span className="card-tag">Mobile</span></div>
              <div style={{marginTop:'12px',paddingTop:'10px',borderTop:'1px solid #d0e2f7',display:'flex',justifyContent:'space-between'}}><span style={{fontSize:'12px',color:'#4a6fa5'}}>Starting at</span><span className="card-price">₹12,000</span></div>
            </div>
            <div className="hero-card hero-card-3">
              <div style={{display:'flex',alignItems:'center',gap:'10px',marginBottom:'14px'}}><div style={{width:'44px',height:'44px',borderRadius:'12px',background:'rgba(5,150,105,0.10)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'22px'}}>🔒</div><div><div style={{fontSize:'14px',fontWeight:700,color:'#0f2340'}}>Escrow Release</div><div style={{fontSize:'12px',color:'#059669'}}>₹5,400 released to Arjun</div></div></div>
              <div style={{height:'6px',borderRadius:'3px',background:'rgba(26,92,219,0.08)',marginBottom:'8px'}}><div style={{width:'65%',height:'100%',borderRadius:'3px',background:'linear-gradient(90deg,#1a5cdb,#059669)'}}></div></div>
              <div style={{fontSize:'11px',color:'#4a6fa5'}}>Milestone 2 of 3 · 65% complete</div>
            </div>
          </div>
        </div>
      </section>

      {/* MARQUEE */}
      <div className="marquee-section">
        <div className="marquee-track">
          {[...Array(20)].map((_, i) => (
            <div key={i} className="marquee-item"><span className="m-dot"></span>{['Web Development', 'Mobile Apps', 'UI/UX Design', 'Digital Marketing', 'Video Editing', 'Content Writing', 'Data Science', 'AI & ML', 'Cloud & DevOps', 'Blockchain'][i % 10]}</div>
          ))}
        </div>
      </div>

      {/* FEATURES */}
      <section id="features">
        <div className="container">
          <div className="section-header">
            <div className="section-tag">✨ Platform Features</div>
            <h2>Everything You Need to<br /><span className="gradient">Hire with Confidence</span></h2>
            <p>India's most complete freelancer platform with built-in payment protection and corporate governance.</p>
          </div>
          <div className="features-grid">
            <div className="feature-card fade-up">
              <div className="feature-icon" style={{background:'rgba(26,92,219,0.08)'}}>🔒</div>
              <h3>Secure Escrow Payments</h3>
              <p>Funds held securely in escrow until you approve. Milestone-based releases protect both clients and freelancers.</p>
            </div>
            <div className="feature-card fade-up fade-up-d1">
              <div className="feature-icon" style={{background:'rgba(5,150,105,0.08)'}}>🏛️</div>
              <h3>Auto Invoicing</h3>
              <p>Professional invoices auto-generated for every transaction. Tax-ready documentation. Clean financial records for your business.</p>
            </div>
            <div className="feature-card fade-up fade-up-d2">
              <div className="feature-icon" style={{background:'rgba(14,165,233,0.10)'}}>📱</div>
              <h3>UPI & Indian Payments</h3>
              <p>Pay via UPI (GPay, PhonePe), Net Banking, NEFT/RTGS, debit/credit cards. Zero international wire fees.</p>
            </div>
            <div className="feature-card fade-up fade-up-d3">
              <div className="feature-icon" style={{background:'rgba(59,130,246,0.12)'}}>✅</div>
              <h3>Milestone Payments</h3>
              <p>Break projects into milestones. Release payments as each milestone is approved. Full visibility and control.</p>
            </div>
            <div className="feature-card fade-up fade-up-d4">
              <div className="feature-icon" style={{background:'rgba(26,92,219,0.08)'}}>🛡️</div>
              <h3>Dispute Resolution</h3>
              <p>Dedicated dispute team with 24-48hr SLA. Fair mediation. Arbitration support. 100% money-back guarantee.</p>
            </div>
            <div className="feature-card fade-up fade-up-d5">
              <div className="feature-icon" style={{background:'rgba(20,184,166,0.12)'}}>🤝</div>
              <h3>Verified Freelancers</h3>
              <p>Aadhaar & PAN verified. Skill assessments. Portfolio reviews. Background checks for enterprise projects.</p>
            </div>
            <div className="feature-card fade-up fade-up-d2">
              <div className="feature-icon" style={{background:'rgba(249,115,22,0.12)'}}>💬</div>
              <h3>Built-in Messaging</h3>
              <p>Real-time chat with freelancers. File sharing. Project discussions. All communication in one place.</p>
            </div>
            <div className="feature-card fade-up fade-up-d3">
              <div className="feature-icon" style={{background:'rgba(34,197,94,0.12)'}}>📊</div>
              <h3>Analytics Dashboard</h3>
              <p>Track spending, team budgets, project timelines. Exportable reports. Real-time insights for SPOC.</p>
            </div>
          </div>
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section id="how" className="how-it-works">
        <div className="container">
          <div className="section-header">
            <div className="section-tag">🚀 Simple Process</div>
            <h2>How <span className="gradient">TaskPiece</span> Works</h2>
            <p>From finding talent to payment release — everything is seamless, secure, and automated.</p>
          </div>
          <div className="steps">
            <div className="step fade-up">
              <div className="step-num">1</div>
              <div className="step-icon">🔍</div>
              <h3>Find Talent</h3>
              <p>Browse 50,000+ verified Indian freelancers. Filter by skill, budget, rating, and location.</p>
            </div>
            <div className="step fade-up fade-up-d2">
              <div className="step-num">2</div>
              <div className="step-icon">🔒</div>
              <h3>Fund Escrow</h3>
              <p>Pay securely via UPI or bank transfer. Funds held in escrow until you approve the work.</p>
            </div>
            <div className="step fade-up fade-up-d4">
              <div className="step-num">3</div>
              <div className="step-icon">🎨</div>
              <h3>Work Gets Done</h3>
              <p>Freelancer delivers milestone by milestone. Review, request revisions, or approve each deliverable.</p>
            </div>
            <div className="step fade-up fade-up-d6">
              <div className="step-num">4</div>
              <div className="step-icon">✅</div>
              <h3>Release Payment</h3>
              <p>Approve and release. Invoice auto-generated for the transaction. Freelancer paid instantly via UPI.</p>
            </div>
          </div>
        </div>
      </section>

      {/* ESCROW DEEP DIVE */}
      <section id="escrow" className="escrow-section">
        <div className="container">
          <div className="section-header">
            <div className="section-tag">🔒 Escrow Protection</div>
            <h2>Your Money is<br /><span className="gradient">100% Protected</span></h2>
            <p>Our secure escrow system ensures you never lose money. Pay only for work you approve.</p>
          </div>
          <div className="escrow-visual">
            <div className="escrow-flow">
              <div className="flow-step fade-up"><div className="flow-num">1</div><div><h4>💰 Buyer Funds Escrow</h4><p>Money moves from your wallet to a secure escrow account. It's held safely — the freelancer can't access it yet.</p></div></div>
              <div className="flow-step fade-up fade-up-d1"><div className="flow-num">2</div><div><h4>🔄 Freelancer Works on Milestones</h4><p>Work is broken into milestones. Each deliverable is submitted for your review independently.</p></div></div>
              <div className="flow-step fade-up fade-up-d2"><div className="flow-num">3</div><div><h4>👁️ You Review & Approve</h4><p>Review each milestone. Request unlimited revisions if needed. Only release payment when satisfied.</p></div></div>
              <div className="flow-step fade-up fade-up-d3"><div className="flow-num">4</div><div><h4>Payment Released Automatically</h4><p>On approval, funds transfer to freelancer. Invoice generated automatically. Everything streamlined.</p></div></div>
              <div className="flow-step fade-up fade-up-d4"><div className="flow-num">5</div><div><h4>⚠️ Dispute? We've Got You Covered</h4><p>Raise a dispute anytime. Our team investigates within 24-48 hours. Full refund guaranteed if seller doesn't deliver.</p></div></div>
            </div>
            <div>
              <div style={{background:'#fff',border:'1px solid var(--border)',borderRadius:'20px',padding:'32px',boxShadow:'0 2px 12px rgba(26,92,219,0.07)'}}>
                <h3 style={{fontSize:'18px',fontWeight:800,marginBottom:'20px',color:'#0f2340'}}>🛡️ Escrow Guarantee</h3>
                <div style={{display:'flex',flexDirection:'column',gap:'14px'}}>
                  <div style={{display:'flex',gap:'12px',alignItems:'flex-start'}}><span style={{color:'#059669',fontSize:'18px'}}>✓</span><div><div style={{fontSize:'14px',fontWeight:700}}>Secure Payment Infrastructure</div><div style={{fontSize:'12px',color:'#4a6fa5'}}>Bank-grade security for all transactions</div></div></div>
                  <div style={{display:'flex',gap:'12px',alignItems:'flex-start'}}><span style={{color:'#059669',fontSize:'18px'}}>✓</span><div><div style={{fontSize:'14px',fontWeight:700}}>100% Money-Back Guarantee</div><div style={{fontSize:'12px',color:'#4a6fa5'}}>Full refund if work isn't delivered</div></div></div>
                  <div style={{display:'flex',gap:'12px',alignItems:'flex-start'}}><span style={{color:'#059669',fontSize:'18px'}}>✓</span><div><div style={{fontSize:'14px',fontWeight:700}}>Milestone-Based Releases</div><div style={{fontSize:'12px',color:'#4a6fa5'}}>Pay only for approved deliverables</div></div></div>
                  <div style={{display:'flex',gap:'12px',alignItems:'flex-start'}}><span style={{color:'#059669',fontSize:'18px'}}>✓</span><div><div style={{fontSize:'14px',fontWeight:700}}>24/7 Dispute Resolution</div><div style={{fontSize:'12px',color:'#4a6fa5'}}>Dedicated team, 24-48hr SLA</div></div></div>
                  <div style={{display:'flex',gap:'12px',alignItems:'flex-start'}}><span style={{color:'#059669',fontSize:'18px'}}>✓</span><div><div style={{fontSize:'14px',fontWeight:700}}>Bank-Grade Security</div><div style={{fontSize:'12px',color:'#4a6fa5'}}>256-bit encryption, PCI DSS compliant</div></div></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CORPORATE */}
      <section id="corporate" className="corporate-section">
        <div className="container">
          <div className="section-header">
            <div className="section-tag">🏢 For Corporates</div>
            <h2>Enterprise-Grade<br /><span className="gradient">SPOC Dashboard</span></h2>
            <p>Centralized control for hiring freelancers at scale. Budget governance, approval workflows, vendor management, and tax automation.</p>
          </div>
          <div className="corp-grid">
            <div className="corp-card fade-up"><div className="corp-icon">👤</div><h3>SPOC Control Panel</h3><p>Single Point of Contact manages all teams, budgets, approvals, and vendor relationships from one dashboard.</p></div>
            <div className="corp-card fade-up fade-up-d1"><div className="corp-icon">✅</div><h3>Approval Workflows</h3><p>Auto-approve under limits. Multi-level approvals for large orders. Priority routing with urgency tags.</p></div>
            <div className="corp-card fade-up fade-up-d2"><div className="corp-icon">💰</div><h3>Team Budget Control</h3><p>Allocate budgets per department. Real-time utilization tracking. Overspend alerts and hard limits.</p></div>
            <div className="corp-card fade-up fade-up-d3"><div className="corp-icon">🤝</div><h3>Vendor Panel</h3><p>Pre-approved vendor roster. Identity verification. Performance tracking. Streamlined management.</p></div>
          </div>
        </div>
      </section>

      {/* PRICING */}
      <section id="pricing">
        <div className="container">
          <div className="section-header">
            <div className="section-tag">💰 Pricing</div>
            <h2>Simple, <span className="gradient">Transparent</span> Pricing</h2>
            <p>No hidden fees. Pay only when projects are completed. Transparent pricing for everyone.</p>
          </div>
          <div className="pricing-grid">
            <div className="price-card fade-up">
              <div className="price-label">Individual</div>
              <div className="price-amount"><span className="currency">₹</span>0</div>
              <div className="price-sub">Free forever · 5% platform fee per order</div>
              <ul className="price-features">
                <li>Access to all freelancers</li>
                <li>Escrow protection</li>
                <li>Milestone payments</li>
                <li>Built-in messaging</li>
                <li>Auto invoices</li>
                <li>UPI & card payments</li>
              </ul>
              <button className="price-btn price-btn-secondary" onClick={handleGetStarted}>Get Started Free</button>
            </div>
            <div className="price-card featured fade-up fade-up-d2">
              <div className="price-label">Business</div>
              <div className="price-amount"><span className="currency">₹</span>4,999<span style={{fontSize:'16px',color:'#4a6fa5'}}>/mo</span></div>
              <div className="price-sub">3.5% platform fee · Billed annually</div>
              <ul className="price-features">
                <li>Everything in Individual</li>
                <li>Up to 10 team members</li>
                <li>Approval workflows</li>
                <li>Team budget management</li>
                <li>Vendor panel (25 vendors)</li>
                <li>Priority support</li>
              </ul>
              <button className="price-btn price-btn-primary" onClick={handleGetStarted}>Start 14-Day Free Trial</button>
            </div>
            <div className="price-card fade-up fade-up-d4">
              <div className="price-label">Enterprise</div>
              <div className="price-amount">Custom</div>
              <div className="price-sub">Volume discounts · Dedicated account manager</div>
              <ul className="price-features">
                <li>Everything in Business</li>
                <li>Unlimited team members</li>
                <li>Unlimited vendor panel</li>
                <li>Custom approval flows</li>
                <li>API integration</li>
                <li>SSO & LDAP</li>
                <li>Dedicated SPOC support</li>
                <li>Custom SLA</li>
              </ul>
              <button className="price-btn price-btn-secondary" onClick={handleGetStarted}>Contact Sales</button>
            </div>
          </div>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section id="testimonials">
        <div className="container">
          <div className="section-header">
            <div className="section-tag">💬 Testimonials</div>
            <h2>Trusted by <span className="gradient">Thousands</span></h2>
            <p>Hear from freelancers and businesses who've transformed their workflow with TaskPiece.</p>
          </div>
          <div className="testimonials-grid">
            <div className="testimonial fade-up">
              <div className="test-stars">★★★★★</div>
              <div className="test-text">"The escrow system gave us complete confidence. We hired 12 freelancers for our product launch and every rupee was accounted for. Invoices auto-generated — our finance team was thrilled!"</div>
              <div className="test-author"><div className="test-avatar">AK</div><div><div className="test-name">Amit Kumar</div><div className="test-role">CTO, FinStack (Bengaluru)</div></div></div>
            </div>
            <div className="testimonial fade-up fade-up-d2">
              <div className="test-stars">★★★★★</div>
              <div className="test-text">"As a freelance designer, getting paid was always stressful. TaskPiece's milestone payments mean I get paid as I deliver. UPI instant transfers are a game-changer."</div>
              <div className="test-author"><div className="test-avatar" style={{background:'linear-gradient(135deg,#0ea5e9,#1a5cdb)'}}>SR</div><div><div className="test-name">Sneha Reddy</div><div className="test-role">UI/UX Designer, Hyderabad</div></div></div>
            </div>
            <div className="testimonial fade-up fade-up-d4">
              <div className="test-stars">★★★★★</div>
              <div className="test-text">"The corporate dashboard is exactly what we needed. Budget controls, approval workflows, vendor management — all in one place. Saved us 35% vs our previous agency model."</div>
              <div className="test-author"><div className="test-avatar" style={{background:'linear-gradient(135deg,#f59e0b,#d97706)'}}>PJ</div><div><div className="test-name">Priyanka Joshi</div><div className="test-role">VP Operations, TechCorp India</div></div></div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-box">
            <div style={{position:'absolute',top:'-60px',left:'-60px',width:'200px',height:'200px',borderRadius:'50%',background:'radial-gradient(circle,rgba(255,255,255,0.12),transparent)',pointerEvents:'none'}}></div>
            <div style={{position:'absolute',bottom:'-40px',right:'-40px',width:'160px',height:'160px',borderRadius:'50%',background:'radial-gradient(circle,rgba(255,255,255,0.08),transparent)',pointerEvents:'none'}}></div>
            <h2>Ready to Hire India's<br /><span style={{color:'rgba(255,255,255,0.85)'}}>Best Freelancers?</span></h2>
            <p>Join 10,000+ businesses and freelancers on India's most trusted platform. Start for free — no credit card required.</p>
            <div style={{display:'flex',gap:'16px',justifyContent:'center',marginTop:'20px'}}>
              <button onClick={handleGetStarted} style={{fontSize:'18px',padding:'18px 40px',background:'#fff',color:'#1a5cdb',borderRadius:'14px',fontWeight:700,border:'none',cursor:'pointer',boxShadow:'0 4px 20px rgba(0,0,0,0.15)',transition:'all 0.3s'}}>🚀 Get Started Free</button>
            </div>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer>
        <div className="container">
          <div className="footer-grid">
            <div className="footer-brand">
              <div style={{marginBottom:'12px'}}><Logo style={{height:'36px',maxWidth:'200px',objectFit:'contain'}} className="" /></div>
              <p>India's trusted freelance marketplace with secure escrow, milestone contracts, and verified professionals. A product of Kottakota Regtech Solutions Pvt Ltd.</p>
            </div>
            <div className="footer-col"><h4>Platform</h4><a onClick={() => navigate('/explore')}>Explore Marketplace</a><a onClick={handleGetStarted}>Post a Project</a><a onClick={() => navigate('/gigs')}>Find Freelancers</a></div>
            <div className="footer-col"><h4>Company</h4><a onClick={() => navigate('/page/about')}>About Us</a><a onClick={() => navigate('/page/contact')}>Contact Us</a></div>
            <div className="footer-col"><h4>Legal</h4><a onClick={() => navigate('/page/terms')}>Terms & Conditions</a><a onClick={() => navigate('/page/privacy-policy')}>Privacy Policy</a><a onClick={() => navigate('/page/refund-policy')}>Refund Policy</a></div>
          </div>
          <div className="footer-bottom">
            <div>&copy; 2026 Kottakota Regtech Solutions Pvt Ltd. All rights reserved.</div>
            <div className="footer-badges">
              <span className="footer-badge">Secure Payments</span>
              <span className="footer-badge">Auto Invoicing</span>
              <span className="footer-badge">Made in India</span>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;
